export default "__VITE_ASSET__w9jB_bFj__"